export enum BulkOperationNotificationType {
    delete = 1,
    hide = 2,
    show = 3,
}
